import style from "./TaskCard.module.css";
import formattedDate from "../../utils/FormatDate";


export default function TaskCard(props) {
    return (
        <>
            <div className={style.taskCard}>
                <div className="card pt-3 pb-1 ps-3 pe-3 shadow p-lg-3">
                    <div className="row">
                        <div className="col-12 col-sm-12 text-center text-lg-start col-lg-5">
                            <h5 className={style.title}>{props.title}</h5>
                        </div>
                        <div className="col-4 col-sm-4 col-lg-3 text-start ps-4 ps-sm-4">
                            <span className={style.perference}>{props.priority}</span>
                        </div>
                        <div className="col-8 col-sm-8 col-lg-4 text-end pe-4 pe-sm-4">
                            <span className={`${style.time}`}>{formattedDate(props.finishingDate)} -{props.finishingTime}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p className={style.description} > {props.description}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">

                            <p className={style.description} >Created By <b>{props.assignedBy}</b></p>
                        </div>
                        <div className="col-lg-6">
                            <p className={style.assignedFor} >Assgined For : <b>{props.assignedFor}</b></p>
                        </div>
                    </div>
                    {props.buttons ?
                        <>
                            <div className="row mx-auto">
                                <div className="col-6">
                                    <button className="btn btn-outline-warning">
                                        Update
                                    </button>
                                </div>

                                <div className="col-6">
                                    <button className="btn btn-outline-danger">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </>
                        :
                        <>
                        </>}

                </div>
            </div>

        </>
    );
}
